<template>
  <footer class="footerMain">
    <div class="footerMain--col footerMain--col1">
      <div class="footerMain--partners">
        <LinkImg v-for="item in parceiros" :key="item.nome"
        :link='item.parceiro.parceiro_link'
        :name='item.parceiro.parceiro_nome'
        :img='item.parceiro.parceiro_logo'/>
      </div>
    </div>

    <div class="footerMain--col footerMain--col2">
      <div class="footerMain--info" v-html="text">
      </div>
    </div>

    <div class="footerMain--col footerMain--col3">
      <div class="footerMain--signature">
        <LinkImg v-for="item in assinaturas" :key="item.nome"
        :link='item.Assinatura.assinatura_link'
        :name='item.Assinatura.assinatura_nome'
        :img='item.Assinatura.assinatura_logo'/>
      </div>
    </div>
  </footer>
</template>

<script>
import { apis } from '@/api.js'
import LinkImg from '../components/_LinkImg'

export default {
  name: 'FooterMain',
  data: function () {
    return {
      url: apis.api.rodapeAPI,
      parceiros: '',
      assinaturas: '',
      rodape: '',
      text: ''
    }
  },
  components: {
    LinkImg
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.parceiros = response[0].parceiros
          this.assinaturas = response[0].assinaturas
          this.text = response[0].text
          this.rodape = response
        })
    }
  },
  created () {
    this.getApi()
  }
}
</script>

<style>

</style>
